import capitalize from 'lodash/capitalize';

export const snakeCaseToText = (s: string): string => {
    const a = s.split('_');
    return a.map(x => capitalize(x)).join(' ');
};

export const textToSnakeCase = (s: string): string => {
    return s.toLocaleLowerCase().replace(/\s|\-/g, '_');
};

export const snakeCaseToTitleCase = (str: string): string => {
    return str
        .split('_')
        .map(x => capitalize(x))
        .join(' ');
};

export const camelToTitleCase = (camelString: string): string => {
    return camelString.replace(/([A-Z])/g, ' $1').replace(/^./, str => {
        return str.toUpperCase();
    });
};

export const sanitizeInput = (input: string): string => {
    // NFD decomposes the string into base characters and combining characters
    // then we replace characters outside of the ASCII range with an empty string
    return input.normalize('NFD').replace(/[^\x00-\x7F]/g, '');
};

/** Unlike lodash capitalize, this function only capitalizes the first letter and does not convert the rest to lower case */
export const capitalizeFirst = (input: string): string => {
    return input ? input.charAt(0).toLocaleUpperCase() + input.slice(1) : input;
};
